const renderSettings = (props: any) => {
    return <div></div>;
};

export default renderSettings;
